import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';

const DEFAULT_STATE = Immutable({
  todayList: true,
  historyList: true,
});

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case ActionTypes.TOGGLE_TODAY_LIST_MODE:
      return state.merge({
        todayList: action.listModeOn,
      });
    case ActionTypes.TOGGLE_HISTORY_LIST_MODE:
      return state.merge({
        historyList: action.listModeOn,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listMode.js